import { Link } from "@tanstack/react-router";
import "./../../styles/embeddedHtmlStyles.scss";
import type { SubscriptionCourseProduct } from "@/api/api.types";
import type { Kurs } from "@/kursy/general";
import { MultimediaCard } from "../Workshop/MultimediaCard";
import { CourseTitleCard } from "./CourseTitleCard";
import { InfoDialogIcon } from "@/components/icons/infoDialog";

interface CourseStudyProps {
	product: SubscriptionCourseProduct;
	kurs?: Kurs;
}

export const CourseStudy = ({ product, kurs }: CourseStudyProps): JSX.Element => {
	return (
		<main className="py-3 pb-5 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			<div className="flex text-fontDarkGray pb-4">
				<Link to="/courses" className="whitespace-nowrap flex-shrink-0">
					Kursy
				</Link>
				<span className="px-4">&#8226;</span>
				<span className="truncate min-w-0">{product.name}</span>
			</div>

			{kurs && (
				<>
					<CourseTitleCard kurs={kurs} />
					<div className="m-8">
						<p className="text-sm text-gray-500">{kurs.description}</p>
					</div>
				</>
			)}

			<div className="flex justify-start items-center m-8 ml-[14px]">
				<InfoDialogIcon className="mr-[15px] flex-shrink-0" />
				<span className="text-sm font-bold min-w-0">
					Materiały dodatkowe do pobrania w zakładce{" "}
					<Link
						to="/my-academy"
						search={{ mainCategory: "FILES" }}
						className="text-blue-500 underline"
					>
						Moja Akademia
					</Link>
				</span>
			</div>

			{product.courseClasses
				.sort((a, b) => a.order - b.order)
				.map((element) => {
					return (
						<MultimediaCard
							key={element.id}
							courseClassData={element}
							productData={{
								productName: product.name,
								productType: "course",
								authors: [],
								productSlug: product.slug,
								productId: product.id.toString(),
							}}
						/>
					);
				})}
		</main>
	);
};
